export default __webpack_public_path__ + "static/media/integrate-megaphone.418e9f83.jpg";